import { combineReducers } from 'redux';
import parent from './parent/parentReducer';

export default combineReducers({
	parent,
});
